
import {
  defineComponent, toRefs, reactive, watch, computed, ref, PropType, ComputedRef, toRaw,
} from 'vue';
import { Checkbox, Radio } from 'ant-design-vue';
import { SearchOutlined } from '@ant-design/icons-vue';
import { definitions } from '@/types/api';

interface CheckboxEvent {
  target: {
    checked: boolean;
    value: string;
  };
}

interface CheckboxLabel {
  label: string;
  value: string;
}

const component = defineComponent({
  name: 'checkbox-for-class',
  components: {
    aCheckbox: Checkbox,
    aCheckboxGroup: Checkbox.Group,
    aRadio: Radio,
    aRadioGroup: Radio.Group,
    SearchOutlined,
  },
  // props: ['classList', 'disabled'],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    classList: {
      type: Array as PropType<definitions['Class'][]>,
      default: () => [],
    },
    type: {
      type: String as PropType<'checkbox'|'radio'>,
      default: 'radio',
    },
  },
  setup(props, context) {
    const showAll = ref(false);

    const plainOptions: ComputedRef<CheckboxLabel[]> = computed(() => {
      const arr = props.classList.map((e: definitions['Class']) => ({
        label: `${e.name}(${e.stuNum})`,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        value: e.id!,
      }));
      if (showAll.value || props.type === 'checkbox') {
        return arr;
      }
      arr.splice(2, arr.length);
      return arr;
    });

    const state = reactive({
      indeterminate: true,
      checkAll: false,
      checkedList: [],
    });

    const onRadioChange = (e: CheckboxEvent) => {
      context.emit('checkChange', [e.target.value]);
    };
    const onCheckChange = () => {
      context.emit('checkChange', [...toRaw(state).checkedList]);
    };

    const onCheckAllChange = (e: CheckboxEvent) => {
      Object.assign(state, {
        checkedList: e.target.checked
          ? plainOptions.value.map((ele: CheckboxLabel) => ele.value)
          : [],
        indeterminate: false,
      });
      onCheckChange();
    };

    const showAllClass = () => {
      showAll.value = !showAll.value;
    };

    watch(
      () => state.checkedList,
      (val) => {
        state.indeterminate = !!val.length && val.length < plainOptions.value.length;
        state.checkAll = val.length === plainOptions.value.length;
        // context.emit('checkChange', state.checkedList);
      }, { deep: true, immediate: true },
    );

    return {
      ...toRefs(state),
      props,
      showAll,
      plainOptions,
      onCheckAllChange,
      showAllClass,
      onRadioChange,
      onCheckChange,
    };
  },
});

export default component;
